var _path, _path2, _ellipse, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19C8 20.6569 6.65685 22 5 22C3.34315 22 2 20.6569 2 19C2 17.3431 3.34315 16 5 16C6.65685 16 8 17.3431 8 19Z",
    fill: "#208C72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19C22 20.6569 20.6569 22 19 22C17.3431 22 16 20.6569 16 19C16 17.3431 17.3431 16 19 16C20.6569 16 22 17.3431 22 19Z",
    fill: "#208C72"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 14,
    rx: 2,
    ry: 2,
    fill: "#F28520"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1 18C14.0344 18.3231 14 18.6575 14 19C14 19.3425 14.0344 19.6769 14.1 20H9.8999C9.96549 19.6769 9.99992 19.3425 9.99992 19C9.99992 18.6575 9.96549 18.3231 9.8999 18H14.1Z",
    fill: "#3360AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4Z",
    fill: "#208C72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89771 6.14062C10.3744 6.60888 11.0067 6.91914 11.71 6.9866L7.97803 14.9836C7.44549 14.5882 6.83159 14.2961 6.16602 14.1371L9.89771 6.14062Z",
    fill: "#3360AD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.29 6.98655L16.022 14.9836C16.5545 14.5881 17.1684 14.296 17.834 14.1371L14.1023 6.14062C13.6257 6.60886 12.9933 6.91911 12.29 6.98655Z",
    fill: "#3360AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelations);
export default __webpack_public_path__ + "static/media/relations.52798c5bfe6b0e6b5ada84e87ae17fbb.svg";
export { ForwardRef as ReactComponent };